import { ContractSearch } from "../../LDS/ContractSearch";
import ARIMemberSearch from "../../ARI/ARIMemberSearch/ARIMemberSearch";
import FIMCMemberSearch from "../../FIMC/FIMCMemberSearch/FIMCMemberSearch";
import { BWCMemberSearch } from "../../BWC/BWCMemberSearch/Index";
import { ATFMemberSearch } from "../../ATF/ATFMemberSearch/Index";
import APIAMemberSearch from "../../APIA/APIAMemberSearch/APIAMemberSearch";
import { CIBCMemberSearch } from "../../CIBC/CIBCMemberSearch/Index";
import CRRMemberSearch from "../../CRR/CRRMemberSearch/CRRMemberSearch";
import ECCMemberSearch from "../../ECC/ECCMemberSearch/ECCMemberSearch";
import { R66MemberSearch } from "../../R66/R66MemberSearch/Index";
import GMIMemberSearch from "../../GMI/GMIMemberSearch/GMIMemberSearch";
import { CGWMemberSearch } from "../../CGW/CGWMemberSearch/Index";
import { NFIMemberSearch } from "../../NFI/NFIMemberSearch/Index";
import BMOMemberSearch from "../../BMO/BMOMemberSearch/BMOMemberSearch";
import { DAAMemberSearch } from "../../DAA/DAAMemberSearch";
import { DHMemberSearch } from "../../D&H/DHMemberSearch";
import { JPLMemberSearch } from "../../JPL/JPLMemberSearch";
import { GSTMemberSearch } from "../../GST/GSTMemberSearch";
import { ATTMemberSearch } from "../../ATT/ATTMemberSearch";
import { CARPMemberSearch } from "../../CARP/CARPMemberSearch";
import { TDMemberSearch } from "../../TD/TDMemberSearch";
import { APEXMemberSearch } from "../../APEX/APEXMemberSearch";
import { PGMemberSearch } from "../../PG/PGMemberSearch";
import { CARSMemberSearch } from "../../CARS/CARSMemberSearch";
import { MMCMemberSearch } from "../../MMC/MMCMemberSearch";
import EFGMemberSearch from "../../EFG/EFGMemberSearch/EFGMemberSearch";
import APAMemberSearch from "../../APA/APAMemberSearch/APAMemberSearch";
import { MJMCMemberSearch } from "../../MJMC/MJMCMemberSearch";
import { CREMemberSearch } from "../../CRE/CREMemberSearch";
import { DRIVOMemberSearch } from "../../DRIVO/DRIVOMemberSearch";
import { MERMemberSearch } from "../../MER/MERMemberSearch";
import { CYSUMemberSearch } from "../../CYSU/CYSUMemberSearch";
import { GKWMemberSearch } from "../../GKW/GKWMemberSearch";
import APCOMemberSearch from "../../APCO/APCOMemberSearch";

function GenericMemberSearch(props) {
  const partner = props.partner;
  const isPortalUser = props.currState.isPortalUser;
  return (
    <>
      {/*Member Lookup Portal*/}
      {(partner === "APIA" ||
        partner === "CH" ||
        partner === "ESTRA" ||
        partner === "CIA" ||
        partner === "MLI" ||
        partner === "OGIA" ||
        partner === "LIS" ||
        partner === "DCAP" ||
        partner === "JIC" ||
        partner === "TIM" ||
        partner === "CP" ||
        isPortalUser) && (
        <APIAMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup ARI*/}
      {(partner === "ARIU" || partner === "ARIC") && (
        <ARIMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup ATF*/}
      {partner === "ATF" && (
        <ATFMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup ATT*/}
      {partner === "ATT" && (
        <ATTMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup APA*/}
      {partner === "APA" && (
        <APAMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup APCO*/}
      {partner === "APCO" && (
        <APCOMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup APEX*/}
      {partner === "APEX" && (
        <APEXMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup BMO*/}
      {partner === "BMO" && (
        <BMOMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
          firstName={props.firstName}
          lastName={props.lastName}
        />
      )}

      {/*Member Lookup BWC*/}
      {partner === "BWC" && (
        <BWCMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
          firstName={props.firstName}
          lastName={props.lastName}
        />
      )}

      {/*Member Lookup CARS*/}
      {partner === "CARS" && (
        <CARSMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup CARP*/}
      {partner === "CARP" && (
        <CARPMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup CGW*/}
      {partner === "CGW" && (
        <CGWMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Search CIBC */}
      {(partner === "CIBC" || partner === "LMC") && (
        <CIBCMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup CRE*/}
      {partner === "CRE" && (
        <CREMemberSearch
          memberSearchService={props.memberSearchService}
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup CRR*/}
      {partner === "CRR" && (
        <CRRMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup CYSU*/}
      {partner === "CYSU" && (
        <CYSUMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup DAA*/}
      {partner === "DAA" && (
        <DAAMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup DH*/}
      {partner === "DH" && (
        <DHMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup DRIVO*/}
      {partner === "DRIVO" && (
        <DRIVOMemberSearch
          memberSearchService={props.memberSearchService}
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup ECC*/}
      {partner === "ECC" && (
        <ECCMemberSearch
          firstName={props.firstName}
          lastName={props.lastName}
          phoneNumber={props.phoneNumber}
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup EFG*/}
      {partner === "EFG" && (
        <EFGMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup CYSU*/}
      {partner === "GKW" && (
        <GKWMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup ECC*/}
      {partner === "GMI" && (
        <GMIMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup FIMC*/}
      {partner === "FIMC" && (
        <FIMCMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup GST*/}
      {partner === "GST" && (
        <GSTMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/* Contract Search LDS */}
      {partner === "LDS" && (
        <ContractSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}
      {/*Member Lookup MER*/}
      {partner === "MER" && (
        <MERMemberSearch
          memberSearchService={props.memberSearchService}
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup MJMC*/}
      {partner === "MJMC" && (
        <MJMCMemberSearch
          memberSearchService={props.memberSearchService}
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
          firstName={props.firstName}
          lastName={props.lastName}
        />
      )}

      {/*Member Lookup MMC*/}
      {(partner === "MMC" || partner === "BTRIN") && (
        <MMCMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
          firstName={props.firstName}
          lastName={props.lastName}
        />
      )}

      {/*Member Lookup NFI*/}
      {partner === "NFI" && (
        <NFIMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup PG*/}
      {partner === "PG" && (
        <PGMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup JPL*/}
      {(partner === "JPLC" || partner === "JPLU") && (
        <JPLMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup R66*/}
      {partner === "R66" && (
        <R66MemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}

      {/*Member Lookup TD*/}
      {partner === "TD" && (
        <TDMemberSearch
          context={props.context}
          currState={props.currState}
          logo={props.logo}
          onUserNext={props.onUserNext}
          onUserBack={props.onUserBack}
          onUserCancel={props.onUserCancel}
        />
      )}
    </>
  );
}

export default GenericMemberSearch;
